import React, { Fragment } from "react";
import {  useSelector, useDispatch } from 'react-redux';
import { updateAPIStatus } from '../Actions/Vat.action';
import { translate } from '../Services/translation';

const VATHeading = () => {
    const showVat = useSelector((state) => state.vat.value);
    const { showVatSection } = window.__litium.websiteConfig;

    const dispatch = useDispatch();
    const updateVatStatus = (event, status) => {
        event.preventDefault();
        dispatch(updateAPIStatus("/api/VAT/SetStatus", { status }));
    };

    const handleVatStatusKeyDown = (event, status) => {
        if (event.key === 'Enter' || event.key === ' ') {
            updateVatStatus(event, status);
        }
    };

    return (
        <Fragment>
            {showVatSection && (
                <div className="vat-outer">
                    <a 
                    tabIndex="0" 
                    className={showVat ? 'active' : ''} 
                    onClick={(event) => updateVatStatus(event, true)}
                    onKeyDown={(event) => handleVatStatusKeyDown(event, true)}
                    > 
                        {translate('vat.include')}
                    </a>
                    <a 
                    tabIndex="0" 
                    className={showVat ? '' : 'active'} 
                    onClick={(event) => updateVatStatus(event, false)}
                    onKeyDown={(event) => handleVatStatusKeyDown(event, false)}
                    > 
                        {translate('vat.exclude')}
                    </a>
                </div>
            )}
        </Fragment>
    );
};

export default VATHeading;